import { fetchUtils, HttpError } from 'react-admin';
import { stringify } from 'query-string';
import pLimit from 'p-limit';
import { apiUrl } from './global';

//const httpClient = fetchUtils.fetchJson;
export const httpClient = (url, options = {}) => {
  if (!options.headers) {
    //options.headers = new Headers({ Accept: 'application/json' });
    options.headers = new Headers();
  }
  // add your own headers here
  const token = localStorage.getItem('token');
  options.headers.set('authorization', token);
  if (options.contentType)
    options.headers.set('Content-Type', options.contentType);
  return fetchUtils.fetchJson(url, options);
};

//压缩图片
const maxWidth = 8000; //8000px 宽度超过8000会压缩
const compressPicture = (file) =>
  new Promise((resolve, reject) => {
    try {
      let { name, type } = file.rawFile;
      if (
        type.toLowerCase() === 'image/jpeg'
        || type.toLowerCase() === 'image/jpg'
        || type.toLowerCase() === 'image/png'
        || type.toLowerCase() === 'image/bmp'
      ) {
        let reader = new FileReader();
        reader.onload = () => {
          let imgBase64 = reader.result;
          let img = new Image();
          img.onload = function () {
            // 默认按比例压缩
            let w = img.width, h = img.height, scale = w / h;
            if (w <= maxWidth)
              resolve(file);
            else {
              console.log('oldFile', `size(M):${file.rawFile.size / 1024 / 1024}`)
              // 默认图片质量为0.85
              let _q = 0.85, _w = maxWidth, _h = _w / scale;

              //生成canvas
              let canvas = document.createElement('canvas'), ctx = canvas.getContext('2d');
              canvas.width = _w;
              canvas.height = _h;
              ctx.drawImage(img, 0, 0, _w, _h);

              // 回调函数返回base64的值
              var base64 = canvas.toDataURL(type, _q);

              // base64编码图片转为File类型
              var arr = base64.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
              while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
              }
              var newFile = { Pics: file.Pics, rawFile: new File([u8arr], `new${name}`, { type: mime }) };

              console.log('newFile', `size(M):${newFile.rawFile.size / 1024 / 1024}`)
              resolve(newFile);
            }
          }
          img.src = imgBase64;
        }
        reader.readAsDataURL(file.rawFile);
      }
      else
        resolve(file);
    } catch (e) { console.log('compressPicture', e) }
  });

const uploadFile = file =>
  new Promise(async (resolve, reject) => {
    //console.log('form value', file);
    if (file == null) {
      resolve(file);
    }
    else if (file.rawFile instanceof File) {
      //deal picture 压缩
      let file2 = await compressPicture(file);
      //upload file
      var formData = new FormData();
      formData.append("file", file2.rawFile);
      httpClient(`${apiUrl}/Admin/File/UploadFile`, {
        method: 'POST',
        body: formData
      }).then(({ json }) => {
        if (json.Code === 1)
          resolve(json.Result.FilePath);
        reject(json.Message);
      })
    }
    else if (Object.prototype.toString.call(file) === '[object Object]') {
      // Nested object
      file = await getUrlFromFiles(file)
        .then(res => res)
        .catch(e => { reject(e) });
      resolve(file);
    } else {
      //already url
      resolve(file);
    }
  })

const getUrlFromFiles = data => {
  //console.log('data',data);return;
  return new Promise(async (resolve, reject) => {
    for (let key of Object.keys(data)) {
      let isArray = data[key] instanceof Array;
      let dataArr = isArray ? data[key] : [data[key]];//转换成Array
      if (dataArr.length > 0) {
        const limit = pLimit(1); //限制并发数为1，不然有时候会TimeOut

        let results = await Promise.all(dataArr.map((d) => limit(() => uploadFile(d))))
          .then(res => res).catch(e => { reject(e); })

        data[key] = isArray ? results : results[0];
      }
    };
    resolve(data);
  })
}

export default {
  getList: (resource, params) => {
    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;
    const query = {
      ...{ _page: page - 1, _pagesize: perPage }, //JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
      ...{ _sort: field, _order: order }, //JSON.stringify([field, order]),
      ...params.filter,
    };

    //console.log('process.env.NODE_ENV:'+process.env.NODE_ENV);

    const url = `${apiUrl}/${resource}/GetList?${stringify(query)}`;

    return httpClient(url).then(({ headers, json }) => {
      if (json.Code == 0)
        return Promise.reject(new HttpError(json.Message, 406, ''));
      return { data: json.Result.data, total: json.Result.total };
    });
  },

  getOne: (resource, params) => {
    return httpClient(`${apiUrl}/${resource}/GetOne/${params.id}`).then(({ json }) => {
      if (json.Code == 0)
        return Promise.reject(new HttpError(json.Message, 406, ''));
      return { data: json.Result };
    });
  },

  getMany: (resource, params) => {
    console.log('params', params)
    const query = {
      ids: params.ids,
    };
    const url = `${apiUrl}/${resource}/GetMany?${stringify(query)}`;
    return httpClient(url).then(({ json }) => {
      if (json.Code == 0)
        return Promise.reject(new HttpError(json.Message, 406, ''));
      return { data: json.Result };
    });
  },

  getManyReference: (resource, params) => {
    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;
    /* const query = {
      sort: JSON.stringify([field, order]),
      range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
      filter: JSON.stringify({
        ...params.filter,
        [params.target]: params.id,
      }),
    }; */
    const query = {
      ...{ _page: page - 1, _pagesize: perPage }, //JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
      ...{ _sort: field, _order: order }, //JSON.stringify([field, order]),
      ...{ [params.target]: params.id },
      ...params.filter,
    };

    const url = `${apiUrl}/${resource}/GetList?${stringify(query)}`;

    return httpClient(url).then(({ headers, json }) => {
      if (json.Code == 0)
        return Promise.reject(new HttpError(json.Message, 406, ''));
      return { data: json.Result.data, total: json.Result.total };
    });
  },

  create: (resource, params) => {
    return new Promise(async (resolve, reject) => {
      //If has Files, get file url from upload file first
      params.data = await getUrlFromFiles(params.data)
        .then(res => res)
        .catch(e => { reject(new HttpError(e, 406, '')) });

      httpClient(`${apiUrl}/${resource}/Create`, {
        method: 'POST',
        body: JSON.stringify(params.data),
      }).then(({ json }) => {
        if (json.Code == 0)
          reject(new HttpError(json.Message, 406, ''));
        resolve({ data: json.Result });
      })
    });
  },

  update: (resource, params) => {
    return new Promise(async (resolve, reject) => {
      //If has Files, get file url from upload file first
      params.data = await getUrlFromFiles(params.data)
        .then(res => res)
        .catch(e => { reject(new HttpError(e, 406, '')) });

      httpClient(`${apiUrl}/${resource}/Update/${params.id}`, {
        method: 'PUT',
        body: JSON.stringify(params.data),
      }).then(({ json }) => {
        if (json.Code == 0)
          reject(new HttpError(json.Message, 406, ''));
        resolve({ data: json.Result });
      })
    });
  },

  updateMany: (resource, params) => {
    const query = {
      ids: params.ids,
    };
    return httpClient(
      `${apiUrl}/${resource}/UpdateMany/${params.data.payload}?${stringify(
        query
      )}`,
      {
        method: 'PUT',
        body: JSON.stringify(params.data.data),
      }
    ).then(({ json }) => {
      if (json.Code == 0)
        return Promise.reject(new HttpError(json.Message, 406, ''));
      return { data: json.Result };
    });
  },

  delete: (resource, params) =>
    httpClient(`${apiUrl}/${resource}/Delete/${params.id}`, {
      method: 'DELETE',
    }).then(({ json }) => {
      if (json.Code == 0)
        return Promise.reject(new HttpError(json.Message, 406, ''));
      return { data: json.Result };
    }),

  deleteMany: (resource, params) => {
    // const query = {
    //   filter: JSON.stringify({id: params.ids}),
    // };
    //return httpClient(`${apiUrl}/${resource}?${stringify(query)}`, {
    return httpClient(`${apiUrl}/${resource}/DeleteMany`, {
      method: 'DELETE',
      body: JSON.stringify({ ids: params.ids }),
    }).then(({ json }) => {
      if (json.Code == 0)
        return Promise.reject(new HttpError(json.Message, 406, ''));
      return { data: json.Result };
    });
  },
};